export default __webpack_public_path__ + "static/coloredited_danalim_data_clark-5901f2a252b779021fe561f676799e6a.png";